import { OcaenFreightRateRequest, FgPriceListRequest, OcaenFreightRateResponseModel, OcaenFreightRateRequestColumns, OceanTotalAmountRequest, } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { PackingMethod } from "../packing-mathods/packing-methods.entity";
import { Product } from "../products/product.entity";
import { Repository } from "typeorm";
import { OcaenFreightRatesEntity } from "./ocean-freights-entity";
import { InjectRepository } from "@nestjs/typeorm";
import { OcaenFreightRateLogsEntity } from "./ocaen-freight-rates-log-entity";
import { FreightsCompany } from "../freights-company/freights-company-entity";
import { Destination } from "../destination/destination.entity";
import { Countries } from "../countries/countries.entity";
import { CommonResponse } from "@gtpl/shared-models/production-management";

@Injectable()

export class OcaenFreightRateService {
    constructor(
        @InjectRepository(OcaenFreightRatesEntity) private repo: Repository<OcaenFreightRatesEntity>,
        @InjectRepository(OcaenFreightRateLogsEntity) private logrepo: Repository<OcaenFreightRateLogsEntity>
    ) { }

    async create(req: any): Promise<OcaenFreightRateResponseModel> {
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction()
            const flag = new Set<boolean>()
            const columnArray = []
            const updatedArray = req.data.map((obj) => {
                const updatedObj = {}
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            })
            const difference = columnArray.filter((element) => !OcaenFreightRateRequestColumns.includes(element));
            console.log(columnArray, 'column');
            console.log(req, 'reqqqqqqqqqqqq');


            console.log(difference, "difference")
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new OcaenFreightRateResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    if (value === "") {
                        updatedObj[key] = null;
                    } else {
                        updatedObj[key] = value;
                    }
                }
                return updatedObj;
            });
            for (const rec of convertedData) {
                console.log(rec, 'reqqqqqqqqqqqq');

                const liner = await transactionManager.getRepository(FreightsCompany).findOne({ where: { name: rec.Liner } })
                console.log(liner, 'linerrrrrrrrrrrrrrrrrrr');

                const destination = await transactionManager.getRepository(Destination).findOne({ where: { destinationName: rec.Destination } })
                console.log(destination, 'dessssssssssssssssssssssssssss');

                const country = await transactionManager.getRepository(Countries).findOne({ where: { countryName: rec.Country } })
                console.log(country, 'connnnnnnnnnnnnnnnnn');

                const existingData = await transactionManager.getRepository(OcaenFreightRatesEntity).findOne({ where: { destinationInfo: destination, countryInfo: country, linerInfo: liner }, relations: ['destinationInfo', 'countryInfo', 'linerInfo'] });
                console.log(existingData, 'ppppppp');

                if (existingData) {
                    const totalPrice = Number(rec.BasicPrice ? rec.BasicPrice : 0) + Number(rec.OtherCharge ? rec.OtherCharge : 0);
                    // existingData.price = rec.Price;
                    const updatedData = await transactionManager.getRepository(OcaenFreightRatesEntity).update({ id: existingData.id }, { basicPrice: rec.BasicPrice, otherCharge: rec.OtherCharge, total: totalPrice,updatedUser:existingData.createdUser });

                    if (updatedData.affected) {
                        const logs = new OcaenFreightRateLogsEntity()
                        logs.basicPrice = existingData.basicPrice
                        logs.effectiveFrom = existingData.createdAt
                        logs.otherCharge = existingData.otherCharge
                        logs.oceanFreight = new OcaenFreightRatesEntity()
                        logs.oceanFreight.id = existingData.id
                        // logs.productId = new Product()
                        logs.total = existingData.total
                        logs.createdUser = existingData.createdUser
                        // logs.FgpriceListId = existingData.id
                        const dataaaaaaa = await transactionManager.getRepository(OcaenFreightRateLogsEntity).save(logs);

                        flag.add(true);
                        // await transactionManager.releaseTransaction()
                    }
                } else {

                    const liner = await transactionManager.getRepository(FreightsCompany).findOne({ where: { name: rec.Liner } })
                    const destination = await transactionManager.getRepository(Destination).findOne({ where: { destinationName: rec.Destination } })
                    const country = await transactionManager.getRepository(Countries).findOne({ where: { countryName: rec.Country } })
                    const totalPrice = Number(rec.BasicPrice ? rec.BasicPrice : 0) + Number(rec.OtherCharge ? rec.OtherCharge : 0);
                    console.log(country, 'pppppppppppppp');

                    const entity = new OcaenFreightRatesEntity()
                    entity.createdUser = req.user
                    // entity.updatedUser = user
                    console.log('datasaaaaaaaaaaaaaaaaaaaaaaaaa');
                    // entity.category = data.Category
                    entity.linerInfo = liner
                    entity.linerInfo.id = liner.id
                    entity.destinationInfo = destination
                    entity.destinationInfo.destinationId = destination.destinationId
                    entity.countryInfo = country
                    entity.countryInfo.countryId = country.countryId
                    entity.basicPrice = rec.BasicPrice
                    entity.otherCharge = rec.OtherCharge
                    entity.total = totalPrice

                    console.log(entity, 'entityyyyyyyyyyyyyy');

                    const savedData = await transactionManager.getRepository(OcaenFreightRatesEntity).save(entity);

                    if (savedData) {
                        flag.add(true);
                    } else {
                        flag.add(false);
                        await transactionManager.releaseTransaction();
                        return new OcaenFreightRateResponseModel(false, 0, 'Something went wrong in saving new data');
                    }
                }
            }

            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new OcaenFreightRateResponseModel(true, 1, 'Data saved successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new OcaenFreightRateResponseModel(false, 0, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new OcaenFreightRateResponseModel(false, 0, err);
        }
    }

    async getAllOcaenFreightRates(): Promise<CommonResponse> {
        try {
            let res = []
            const query = `SELECT ofr.total,ofr.basic_price as basicPrice,ofr.other_charge as otherCharge, d.destination_name as destination,c.country_name as country,l.name as liner,ofr.updated_at as updatedAt FROM ocaen_freight_rates ofr
            LEFT JOIN destination d ON d.destination_id =ofr.destination_id
            LEFT JOIN countries c ON c.country_id = ofr.country_id
            LEFT JOIN freights_company l ON l.id = ofr.liner_id
            ORDER BY c.country_name`
            const info = await this.repo.query(query);
            console.log(info, 'ppppppppp');

            if (info.length > 0) {

                return new CommonResponse(true, 1, 'Data retrieved', info)
            } else {
                return new CommonResponse(false, 0, 'No data found')
            }
        } catch (err) {
            return new CommonResponse(false, 0, 'Something went wrong', err)
        }
    }
    async getAllOcaenFreightRatesForInvoice(req: OceanTotalAmountRequest): Promise<CommonResponse> {
        if (!req.countryId && !req.destinationId && !req.linerId) {
            return new CommonResponse(false, 0, 'All request parameters are null');
        }
    
        try {
            let query = `SELECT ofr.id, ofr.total,ofr.basic_price AS basicPrice,ofr.other_charge AS otherCharge,ofr.country_id,ofr.destination_id,ofr.liner_id,d.destination_name AS destination,c.country_name AS country,l.name AS liner,ofr.updated_at as updatedAt FROM ocaen_freight_rates ofr
                       LEFT JOIN destination d ON d.destination_id =ofr.destination_id
                       LEFT JOIN countries c ON c.country_id = ofr.country_id
                       LEFT JOIN freights_company l ON l.id = ofr.liner_id
                       where ofr.id > 0 `;
            if (req.countryId) {
                query = query + ' and ofr.country_id = ' + `${req.countryId}`
            };
            if (req.destinationId) {
                query = query + ' and ofr.destination_id = ' + `${req.destinationId}`
            };
            if (req.linerId) {
                query = query + ' and ofr.liner_id = ' + `${req.linerId}`
            }
            const info = await this.repo.query(query);
            console.log(info, 'ppppppppp');
    
            if (info.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved', info)
            } else {
                return new CommonResponse(false, 0, 'No data found')
            }
        } catch (err) {
            return new CommonResponse(false, 0, 'Something went wrong', err)
        }
    }
    
}